import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=b8f53a38"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=b8f53a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports